import { Component, inject } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { NoOpLink, ShowForRoleInDirective } from "@kno2/common/directives";
import { SessionService } from "@kno2/core/session";
import { OrgSwitcherComponent } from "@kno2/features/account";
import { SEND_AN_INVITE_DIALOG_CONFIG, SendAnInviteModalComponent } from "@kno2/features/invitations";
import { DialogService } from "@kno2/shared/dialog";
import { LoadingIndicatorComponent } from "@kno2/shared/loading-indicator";
import { ProfileMenuComponent } from "./profile-menu/profile-menu.component";
import { SettingsMenuComponent } from "./settings-menu/settings-menu.component";

@Component({
    selector: "kno2-header",
    imports: [OrgSwitcherComponent, ProfileMenuComponent, SettingsMenuComponent, LoadingIndicatorComponent, ShowForRoleInDirective, NoOpLink, RouterLink],
    templateUrl: "./header.component.html"
})
export class HeaderComponent {
    private readonly sessionService = inject(SessionService);
    private readonly dialogService = inject(DialogService);
    private readonly router = inject(Router);

    protected readonly currentUser = this.sessionService.profileData;

    protected goHome(): void {
        this.router.navigateByUrl(this.sessionService.getDefaultRouteForActiveRole());
    }

    public openInvitationModal(): void {
        this.dialogService.open(SendAnInviteModalComponent, SEND_AN_INVITE_DIALOG_CONFIG);
    }

    public async updateProfile(): Promise<void> {
        await this.sessionService.refreshProfile();
    }
}
